import React from 'react';
import './TestPage.scss';

const TestPage: React.FC = () => {
  return (
    <div className="test-page">
      <h1>Test Page</h1>
      <p>Це тестова сторінка для перевірки layout</p>

      <div className="test-page__content">
        <div className="test-page__box">Box 1</div>
        <div className="test-page__box">Box 2</div>
        <div className="test-page__box">Box 3</div>
      </div>

      <div className="test-page__long-content">
        <h2>Довгий контент для тестування скролу</h2>
        {Array.from({ length: 20 }, (_, i) => (
          <p key={i}>
            Параграф {i + 1}: Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
        ))}
      </div>
    </div>
  );
};

export default TestPage;